/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import * as S from './styles';

type Props = {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
};

const MenuItem = ({ children, href, onClick }: Props) => {
  const linkIsExternal = href && /^https?:\/\//.test(href);

  const itemType = useMemo(() => {
    if (!href) {
      return <button type="button" onClick={onClick} />;
    }

    return linkIsExternal ? <a href={href} /> : <Link to={href} />;
  }, [href, linkIsExternal, onClick]);

  return (
    <S.MenuItem type={itemType}>
      {children} <S.Arrow />
    </S.MenuItem>
  );
};

export default MenuItem;
